import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from 'axios'
import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import '@/assets/css/global.css'


const app = createApp(App)
app.config.globalProperties.$axios = axios
app.use(store).use(router).use(ElementPlus).use(ViewUIPlus).mount('#app')
axios.defaults.baseURL = process.env.NODE_ENV === "production" ? "http://115.239.191.46:6012" : process.env.VUE_APP_API
